import BaseClient from '../base/baseClient';
import endpoint from '../../features/endPoints/ecommEndpoints';

const LogoutUserClient = async () => {
    const { post: postClient } = BaseClient();
    try {
        return await postClient(process.env.REACT_APP_ECOMM_URL + endpoint.logout(), null, {}, true);
    } catch (error) {
        return { error: 'Logout failed. Please try again'  };
    }
};

export default LogoutUserClient;




